import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Cliente, CreateClienteDto, UpdateClienteDto } from '../cliente.model';

/**
 * Servicio para gestionar operaciones CRUD de clientes
 * Los errores HTTP son manejados automáticamente por el errorInterceptor
 */
@Injectable({
  providedIn: 'root'
})
export class ClientesService {

  private readonly URL = environment.URL;

  constructor(private readonly http: HttpClient) { }

  /**
   * Agrega un nuevo cliente
   * @param cliente - Datos del cliente a crear
   * @returns Observable con la respuesta del servidor
   */
  addCliente(cliente: CreateClienteDto): Observable<any> {
    return this.http.post<any>(this.URL + 'addCliente', cliente);
  }

  /**
   * Elimina un cliente por su ID
   * @param idCliente - ID del cliente a eliminar
   * @returns Observable con la respuesta del servidor
   */
  deleteCliente(idCliente: number): Observable<any> {
    return this.http.delete<any>(this.URL + `deleteCliente/${idCliente}`);
  }

  /**
   * Actualiza los datos de un cliente
   * @param data - Nuevos datos del cliente
   * @param idCliente - ID del cliente a actualizar
   * @returns Observable con la respuesta del servidor
   */
  editCliente(data: UpdateClienteDto, idCliente: number): Observable<any> {
    return this.http.put<any>(this.URL + `editCliente/${idCliente}`, data);
  }

  /**
   * Obtiene la lista completa de clientes
   * @returns Observable con el array de clientes
   */
  listClientes(): Observable<Cliente[]> {
    return this.http.get<Cliente[]>(this.URL + 'listClientes');
  }
}

